import { carrierRateTablesSchema } from "@redotech/redo-model/rate-table/global-rate-tables";
import * as z from "zod";

export const saveBaselineRateTables = {
  name: "saveBaselineRateTables" as const,
  input: z.object({ rateTables: carrierRateTablesSchema }),
  output: z.object({ success: z.boolean() }),
};
